// ─── Status Constants ───────────────────────────────────────
// Use these constants instead of string literals to get compile-time safety.
// The types are derived from the const objects so they stay in sync automatically.
/** All valid session lifecycle statuses. Import and use these instead of string literals. */
export const SESSION_STATUS = {
    PENDING: "pending",
    RUNNING: "running",
    IDLE: "idle",
    STOPPED: "stopped",
    SUSPENDED: "suspended",
};
/** Session statuses that represent a terminal (ended) state. */
export const TERMINAL_SESSION_STATUSES = new Set([
    SESSION_STATUS.STOPPED,
]);
/** Why a session stopped. Only meaningful when status is STOPPED. */
export const END_REASON = {
    COMPLETED: "completed",
    KILLED: "killed",
    INTERRUPTED: "interrupted",
    TERMINATED: "terminated",
    BUDGET_EXCEEDED: "budget_exceeded",
};
/** All valid task lifecycle statuses. Import and use these instead of string literals. */
export const TASK_STATUS = {
    NOT_STARTED: "not_started",
    WORKING: "working",
    PAUSED: "paused",
    COMPLETE: "complete",
    FAILED: "failed",
};
// ─── Constants ──────────────────────────────────────────────
/** Default port the PowerLine gRPC server listens on. */
export const DEFAULT_POWERLINE_PORT = 7433;
/** Default port the central Grackle gRPC server listens on. */
export const DEFAULT_SERVER_PORT = 7434;
/** Default port for the web UI and WebSocket bridge. */
export const DEFAULT_WEB_PORT = 3000;
/** Default port for the MCP (Model Context Protocol) server. */
export const DEFAULT_MCP_PORT = 7435;
/** Default port for the MCP Apps widget sandbox (a separate origin for the double-iframe). */
export const DEFAULT_SANDBOX_PORT = 7436;
/** Name of the seed persona created on first run. */
export const DEFAULT_PERSONA_NAME = "Software Engineer";
/** ID of the seed persona created on first run. */
export const SEED_PERSONA_ID = "claude-code";
/** Name of the Grackle config directory under the user's home. */
export const GRACKLE_DIR = ".grackle";
/** SQLite database filename. */
export const DB_FILENAME = "grackle.db";
/** Subdirectory for session log files. */
export const LOGS_DIR = "logs";
/** Filename for the locally-stored API key. */
export const API_KEY_FILENAME = "api-key";
/** Maximum allowed nesting depth for task hierarchies. */
export const MAX_TASK_DEPTH = 8;
/** Well-known ID for the System persona (orchestrator). */
export const SYSTEM_PERSONA_ID = "system";
/** Display name for the System persona. */
export const SYSTEM_PERSONA_NAME = "System";
/** Well-known ID for the root task (always present). */
export const ROOT_TASK_ID = "system";
/** Initial prompt sent to the root task on auto-start (and manual restart). */
export const ROOT_TASK_INITIAL_PROMPT = "Introduce yourself and Grackle!";
/** Well-known ID for the default workspace (created on first run, tied to local env). */
export const DEFAULT_WORKSPACE_ID = "default";
/** Default maximum concurrent agent sessions when no limit is configured. */
export const DEFAULT_MAX_CONCURRENT_SESSIONS = 4;
/** Settings-store key for the global concurrent session limit. */
export const SETTINGS_KEY_MAX_CONCURRENT_SESSIONS = "max_concurrent_sessions";
//# sourceMappingURL=types.js.map